const SERIES = {
  fw: 'Fixed Window 100 Series',
  sh: 'Single Hung 100 Series',
  hr: 'Horizontal Roller 100 Series',
  fd: 'French Door',
  sgd: 'Sliding Glass Door',
};

export default (system) => SERIES[system.type];
